import React, { useState } from 'react';
import { WorkflowEventTypes } from '@amzn/awscat-pattern-library-service-model';
import { createWorkflowEventWithStatePolling } from '../../api/CreateWorkflowEventWithStatePolling';
import constants from '../../common/constants';
import FlashbarMessageBroker from '../../common/FlashbarMessageBroker';
import ModalDialogButtonV3 from '../common/ModalDialogButtonV3';
import { StateCol } from '../content-requests/ContentRequestColumnDefinition';

export const SkipNextDraftReviewButton = (props: {
  contentId: string;
  draftWorkflowId: number;
  disabled: boolean;
}) => {
  const [disabled, setDisabled] = useState(false);
  const flashbarMessageBroker = FlashbarMessageBroker.create();

  const skipDraftReview = async () => {
    const { contentId, draftWorkflowId } = props;
    try {
      await createWorkflowEventWithStatePolling(
        contentId,
        draftWorkflowId,
        WorkflowEventTypes.SKIP_DRAFT_REVIEW,
        '',
      );
      setDisabled(true);
      flashbarMessageBroker.pushSuccessMessage(constants.SKIP_DRAFT_REVIEW_SUCCESS_MESSAGE);
    } catch (e) {
      flashbarMessageBroker.pushErrorMessage(constants.SKIP_DRAFT_REVIEW_SUCCESS_MESSAGE);
    }
  };

  return (
    <ModalDialogButtonV3
      variant="normal"
      header={constants.SKIP_DRAFT_REVIEW_MODAL_HEADER}
      text={constants.SKIP_DRAFT_REVIEW_MODAL_TEXT}
      onSubmit={skipDraftReview}
      submitButtonText={constants.SKIP_DRAFT_REVIEW_BUTTON_TEXT}
      disabled={props.disabled || disabled}
    />
  );
};
